/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Datastore API
 * API reference for Datastore API.
 *
 * Authentication: Auth0
 *
 * OpenAPI spec version: 3.0.0
 */
import type {
  GetBoxConnectionCredentialResponse,
  TestBoxConnectionResponse,
  UpsertBoxConnectionCredentialRequestBody,
  UpsertBoxConnectionCredentialResponse
} from '../model';

import getBoxConnectionCredentialMutator from '../../../mutators/datastore-instance';
import upsertBoxConnectionCredentialMutator from '../../../mutators/datastore-instance';
import testBoxConnectionMutator from '../../../mutators/datastore-instance';



  /**
 * 組織に登録された Box 接続情報を取得します。
 * 未登録の場合は registered=false を返し、登録済みの場合は client_id と enterprise_id を含めて返します。
 * client_secret は機密情報のため返却しません。
 * @summary Box 接続情報取得
 */
export const getBoxConnectionCredential = (

 ) => {
      return getBoxConnectionCredentialMutator<GetBoxConnectionCredentialResponse>(
      {url: `/external-storages/box/credentials`, method: 'GET'
    },
      );
    }
  /**
 * 組織あたり 1 件の Box 接続情報を登録します (upsert)。
 * 新規登録時は 201 Created、上書き時は 200 OK を返します。
 * client_secret は機密情報のため返却しません。
 * @summary Box 接続情報登録 (upsert)
 */
export const upsertBoxConnectionCredential = (
    upsertBoxConnectionCredentialRequestBody?: UpsertBoxConnectionCredentialRequestBody,
 ) => {
      return upsertBoxConnectionCredentialMutator<UpsertBoxConnectionCredentialResponse>(
      {url: `/external-storages/box/credentials`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: upsertBoxConnectionCredentialRequestBody
    },
      );
    }
  /**
 * リクエストボディの接続情報で Box への認証が成立するかをテストします。
 * 本エンドポイントの呼び出し結果は永続化されません。
 * @summary Box 接続テスト
 */
export const testBoxConnection = (
    upsertBoxConnectionCredentialRequestBody?: UpsertBoxConnectionCredentialRequestBody,
 ) => {
      return testBoxConnectionMutator<TestBoxConnectionResponse>(
      {url: `/external-storages/box/test-connection`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: upsertBoxConnectionCredentialRequestBody
    },
      );
    }
  export type GetBoxConnectionCredentialResult = NonNullable<Awaited<ReturnType<typeof getBoxConnectionCredential>>>
export type UpsertBoxConnectionCredentialResult = NonNullable<Awaited<ReturnType<typeof upsertBoxConnectionCredential>>>
export type TestBoxConnectionResult = NonNullable<Awaited<ReturnType<typeof testBoxConnection>>>
